/**
 * Создает новый объект File с переименованным именем
 * Сохраняет расширение файла, если оно не указано в новом имени
 * @param {File} originalFile - Исходный файл
 * @param {string} newFileName - Новое имя файла
 * @returns {File} - Новый объект File с новым именем
 */
const createRenamedFile = (originalFile, newFileName) => {
  if (!originalFile || !newFileName) {
    return originalFile;
  }
  
  // Получаем расширение из исходного файла
  const originalFileName = originalFile.name;
  const lastDotIndex = originalFileName.lastIndexOf('.');
  const originalExtension = lastDotIndex !== -1 ? originalFileName.substring(lastDotIndex) : '';
  
  // Проверяем, есть ли расширение в новом имени
  const newLastDotIndex = newFileName.lastIndexOf('.');
  const hasExtension = newLastDotIndex !== -1 && newLastDotIndex > 0;
  
  // Если расширения нет, добавляем его из исходного файла
  const finalFileName = hasExtension ? newFileName : newFileName + originalExtension;
  
  // Создаем новый File объект с новым именем
  // File конструктор: new File(bits, name, options)
  return new File([originalFile], finalFileName, {
    type: originalFile.type,
    lastModified: originalFile.lastModified
  });
};

export default createRenamedFile;

